import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ModalServiceService } from '../modal-service/modal-service.service';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
import { LoaderFactory } from '@shared/factories/loader/loader.factory';
import { ApiServiceService } from '../api-service/api-service.service';

@Injectable()
export class OrganizationModalService {

  newClient$ = new Subject<any>();

  constructor(
    private modalService: ModalServiceService,
    private translate: AfTranslateFactory,
    private loader: LoaderFactory,
    private apiService: ApiServiceService
  ) {

  }

  async createNewClient(clientNew: any): Promise<any> {
    const itemSelected = {
      type: 'create-client',
      item: clientNew.client
    };
    return new Promise((resolve: any, reject: any) => {
      this.modalService.informativeLoadingModal(itemSelected)
        .subscribe({
          next: (result: any) => {
            if (result.result === 'cancel') {
              reject();
            }
            clientNew.logo
              ? this.addLogoToClient(clientNew, result.item)
              : this.modalService.successModal({ text: this.translate.instant('dashboard.data-saved-ok') })
            resolve(clientNew.client);
          },
          error: (errorData: any) => {
            reject();
          }
        });
    });
  }

  addLogoToClient(result: any, client: any) {
    this.loader.openLoader('add-logo');
    this.apiService.attachFilePatch(`clients/${client.clientId}/logos`, result.logo)
      .then((data: any) => {
        this.modalService.successModal({ text: this.translate.instant('dashboard.data-saved-ok') })
      }, (error: any) => {
        this.modalService.errorModal({ text: this.translate.instant('public-link.error-configuration-share-link') });
      }).finally(() => {
        this.loader.closeLoader('add-logo');
      });
  }
}
